import React from "react";
import { FileDown, FileText } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";
import { useReveal } from "../hooks/useReveal";

const CATALOG_URLS = {
  it: "https://drive.google.com/file/d/1hqy-j931wKZZXAcNOv52fz0a_hIbTCMi/view?usp=sharing",
  en: "https://drive.google.com/file/d/1RQvPdJ_-MGLqhyb6fPak079gBqkgVOhb/view?usp=sharing",
};

export const PdfDownload = () => {
  const { t, lang } = useI18n();
  const { ref, visible } = useReveal();
  const catalogUrl = CATALOG_URLS[lang] || CATALOG_URLS.it;

  return (
    <section
      ref={ref}
      id="scarica-catalogo"
      data-testid="pdf-download-section"
      className={`reveal ${visible ? "visible" : ""} bg-white py-20 md:py-28`}
    >
      <div className="pb-container">
        <div
          data-testid="pdf-download-banner"
          className="relative bg-[#1a3a2a] text-white grain overflow-hidden"
        >
          {/* Decorative gold lines */}
          <span className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#c9a84c] to-transparent opacity-60" />
          <span className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#c9a84c] to-transparent opacity-60" />

          <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-center px-8 md:px-14 py-12 md:py-16">
            <div className="lg:col-span-2 flex lg:justify-center">
              <div className="w-20 h-24 border border-[#c9a84c]/50 flex items-center justify-center">
                <FileText className="w-10 h-10 text-[#c9a84c]" strokeWidth={1.25} />
              </div>
            </div>

            <div className="lg:col-span-7">
              <div className="flex items-center gap-4 mb-4">
                <span className="block w-10 h-px bg-[#c9a84c]" />
                <span className="text-overline">{t.pdf.overline}</span>
              </div>
              <h3 className="font-heading font-bold text-2xl md:text-4xl tracking-tight uppercase leading-tight">
                {t.pdf.title}
              </h3>
              <p className="mt-3 text-white/70 text-base md:text-lg max-w-xl leading-relaxed">
                {t.pdf.sub}
              </p>
            </div>

            <div className="lg:col-span-3 flex lg:justify-end">
              <a
                href={catalogUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="pdf-download-button"
                className="group inline-flex items-center gap-3 px-6 py-4 bg-[#c9a84c] hover:bg-[#b39440] text-[#1a3a2a] font-semibold text-sm tracking-widest uppercase transition-colors"
              >
                <FileDown
                  className="w-5 h-5 group-hover:translate-y-0.5 transition-transform"
                  strokeWidth={2}
                />
                {t.pdf.cta}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
